import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {QbCustomerDto} from "../model/QbCustomerDto";

class QbCustomerSearchController implements IComponentController {
    records: QbCustomerDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.client.bindAllQbCustomer(() => this.records);
    }


    search = (query) => {
        this.records = [];
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.server.qbCustomerSubscribeSearch(query);
    }
}

export default angular.module('component.qbCustomerSearch', [])
    .component('qbCustomerSearch', {
        template: require('./QbCustomerSearch.html'),
        controller: QbCustomerSearchController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
